import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'
import type {TAuthenticatedPlayerDetails} from '@kapitalist/contract/types'
import AuthenticatedPlayer from '~/models/app/AuthenticatedPlayer'

export type AuthenticatedPlayerState = {
  authenticatedPlayer: AuthenticatedPlayer | undefined
}

const initialState: AuthenticatedPlayerState = {
  authenticatedPlayer: undefined,
}

const authenticatedPlayerSlice = createSlice({
  name: 'authenticatedPlayer',
  initialState,
  reducers: {
    setAuthenticatedPlayer(
      state: AuthenticatedPlayerState,
      action: PayloadAction<TAuthenticatedPlayerDetails>
    ) {
      const authenticatedPlayer = new AuthenticatedPlayer(action.payload)
      return {authenticatedPlayer}
    },
  },
})

const {setAuthenticatedPlayer} = authenticatedPlayerSlice.actions
export {setAuthenticatedPlayer}
export default authenticatedPlayerSlice.reducer
